import { render, staticRenderFns } from "./FilesRelated.vue?vue&type=template&id=a792061a&scoped=true&"
import script from "./FilesRelated.vue?vue&type=script&lang=js&"
export * from "./FilesRelated.vue?vue&type=script&lang=js&"
import style0 from "./FilesRelated.vue?vue&type=style&index=0&id=a792061a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a792061a",
  null
  
)

export default component.exports